export const allstoresValue ={storeId: '9999', isDairy:"N"};